import combineComparators from 'commons/js/util/combineComparators'

function byLatitudeAsc (left, right) {
    return right.latitude - left.latitude
}

function makeStickyComparator (id) {
    return function byStickyId (left, right) {
        if (left.id === id) return 1
        if (right.id === id) return -1

        return 0
    }
}

export function makeMarkersComparator (stationId) {
    return combineComparators(
        makeStickyComparator(stationId),
        byLatitudeAsc
    )
}
